import React__default, { forwardRef } from 'react';
import { MessagingContent } from '../messagingContent.js';

function BannerComponent(props, ref) {
    return React__default.createElement(MessagingContent, Object.assign({}, props, { componentName: "banner", ref: ref }));
}
const Banner = forwardRef(BannerComponent);

export { Banner };
